export default {
  portal: {
    brand: 'Partner Portal',
    hubLink: 'Partner Hub',
    supplierLine: 'Supplier portal for Treejar',
    nav: {
      section: 'Workspace',
      home: 'Home',
      products: 'Products',
      upload: 'Upload price list',
      demand: 'Demand',
      reservations: 'Reservations',
      orders: 'Orders',
      finance: 'Finance',
      warranty: 'Warranty',
      contract: 'Contract & terms',
      team: 'Team',
      more: 'More',
      menu: 'Menu',
      signOut: 'Sign out',
    },
    shell: {
      partnerAccount: 'Partner account',
      contractActive: 'Contract active',
      notifications: 'Notifications',
      openNav: 'Open navigation',
      closeNav: 'Close navigation',
      userRole: 'Owner',
      hub: 'Treejar Partner Hub',
      manager: 'Treejar manager',
      stockLoading: 'Loading workspace',
    },
    notif: {
      title: 'Notifications',
      unread: '{{count}} new',
      allRead: 'All read',
      markAll: 'Mark all read',
      filterAll: 'All',
      filterOrders: 'Orders',
      filterReservations: 'Reservations',
      filterPayments: 'Payments',
      empty: 'Nothing here yet',
      emptyHint: 'New orders, reservations and payments appear instantly.',
      showAll: 'All orders',
      settings: 'Settings',
      orderTitle: 'New order {{po}} from Treejar',
      orderBody: '{{sku}} × {{qty}} · {{amount}} at partner price',
      orderBodyShort: '{{units}} units · {{amount}} at partner price',
      reservationTitle: 'Reservation {{no}} expires {{when}}',
      reservationBody: '{{spec}} · {{units}} units awaiting confirmation',
      paymentTitle: 'Payment received · {{amount}}',
      paymentBody: 'Invoice {{invoice}} settled · order {{po}}',
      paymentDueTitle: 'Invoice {{invoice}} awaiting payment',
      paymentDueBody: '{{amount}} · due {{date}}',
      inDays: 'in {{count}} days',
      inToday: 'today',
      time: {
        justNow: 'Just now',
        minutes: '{{count}} min ago',
        hours: '{{count}} h ago',
        days: '{{count}} days ago',
        today: 'Today',
      },
    },
    common: {
      save: 'Save',
      saved: 'Saved',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      search: 'Search',
      all: 'All',
      back: 'Back',
      view: 'View',
      open: 'Open',
      download: 'Download',
      upload: 'Upload',
      send: 'Send',
      reason: 'Reason',
      status: 'Status',
      actions: 'Actions',
      total: 'Total',
      quantity: 'Quantity',
      date: 'Date',
      amount: 'Amount',
      due: 'Due',
      note: 'Note',
      units: 'units',
      items: 'items',
      days: 'days',
      day: 'day',
      hours: 'h',
      aed: 'AED',
      sku: 'SKU',
      product: 'Product',
      updated: 'Updated',
      from: 'from',
      to: 'to',
      none: 'None',
      add: 'Add',
      apply: 'Apply',
      reset: 'Reset',
      select: 'Select',
      optional: 'optional',
      dismiss: 'Dismiss',
      showing: 'Showing {{shown}} of {{total}}',
      ago: '{{count}} days ago',
      today: 'Today',
    },
    status: {
      New: 'New',
      Confirmed: 'Confirmed',
      AwaitingPayment: 'Awaiting payment',
      Paid: 'Paid',
      Shipped: 'Shipped',
      ReadyForPickup: 'Ready for pickup',
      PickedUp: 'Picked up',
      Closed: 'Closed',
      WarrantyCase: 'Warranty case',
      Active: 'Active',
      Converted: 'Converted to order',
      Expired: 'Expired',
      Declined: 'Declined',
      UnderReview: 'Under review',
      Published: 'Published',
      Discontinued: 'Discontinued',
      Open: 'Open',
      ReplacementAgreed: 'Replacement agreed',
      Invited: 'Invited',
    },
    login: {
      title: 'Partner portal for Treejar suppliers',
      subtitle: 'Keep your stock up to date, confirm reservations and follow orders and payments — in one place.',
      email: 'Email',
      emailPlaceholder: 'name@company.ae',
      password: 'Password',
      passwordPlaceholder: 'Your password',
      forgot: 'Forgot password',
      signIn: 'Sign in',
      signingIn: 'Signing in',
      remember: 'Keep me signed in on this device',
      hint: 'Use your work email. Warehouse staff can sign in on a phone.',
      errorEmpty: 'Enter your email and password.',
      errorInvalid: 'Email or password is not recognised. Check the details or reset your password.',
      resetTitle: 'Password reset',
      resetBody: 'A reset link has been prepared for {{email}}. In this demo no email is actually sent.',
      demoTitle: 'Demo account',
      demoBody: 'partner@alkanz.ae · demo1234',
      demoFill: 'Use demo account',
      backToLogin: 'Back to sign in',
      feature1Title: 'Stock, always current',
      feature1Text: 'Update quantities from the warehouse floor in a few taps.',
      feature2Title: 'Orders without phone calls',
      feature2Text: 'Confirm orders and set ready dates straight from the portal.',
      feature3Title: 'Payments you can predict',
      feature3Text: 'See what Treejar owes you and when it is expected.',
      secure: 'Secure partner access · Treejar Trading LLC',
      switchHint: 'Your language is remembered on this device.',
    },
    home: {
      eyebrow: 'Saturday, 24 October 2026',
      title: 'Good morning, Al Kanz',
      description: 'Your warehouse in Sharjah is connected to Treejar. Two orders need a confirmation today.',
      attention: 'Needs your attention',
      cardOrdersTitle: '{{count}} new orders to confirm',
      cardOrdersBody: 'PO-2026-0145 and PO-2026-0146 · AED 44,300 at partner price',
      cardOrdersCta: 'Review orders',
      cardResTitle: '{{count}} reservations expiring in 48 h',
      cardResBody: 'R-0305, R-0309 and R-0311 · 115 units held for Treejar specifications',
      cardResCta: 'Open reservations',
      cardStockTitle: 'Stock not updated for 9 days',
      cardStockBody: 'CH-229A, ST-180D and 5 other SKUs have no stock update since 15 Oct.',
      cardStockCta: 'Update stock now',
      kpiPublished: 'Products published',
      kpiPublishedHint: 'of 156 SKUs in your catalog',
      kpiStock: 'Units in stock',
      kpiStockHint: 'across 156 SKUs',
      kpiReserved: 'In active reservations',
      kpiReservedHint: 'held for Treejar specs',
      kpiOrders: 'Orders this month',
      kpiOrdersHint: '6 orders · AED 84,300',
      kpiAwaiting: 'Awaiting payment',
      kpiAwaitingHint: '2 invoices · due 2 Nov',
      timelineTitle: 'Recent activity',
      timelineSub: 'Orders, payments and reservations from Treejar',
      snapshotTitle: 'Account snapshot',
      snapshotSub: 'Contract, terms and your next payment',
      contractLabel: 'Contract',
      contractValue: 'Active until 31 Oct 2027',
      discountLabel: 'Partner discount',
      discountValue: '22% off list price',
      reservationPeriodLabel: 'Reservation period',
      reservationPeriodValue: '7 days from confirmation',
      nextPaymentLabel: 'Next expected payment',
      nextPaymentValue: 'AED 25,575 · 06 Nov',
      managerLabel: 'Your Treejar manager',
      managerName: 'Layla Hassan',
      managerRole: 'Partner manager · Treejar Trading',
      viewAll: 'View all',
      note: 'Treejar never shares end-client details or resale prices with you.',
      evOrder: 'New order {{po}} received · {{units}} units',
      evPayment: 'Payment received · {{amount}} for {{invoice}}',
      evReservation: 'Reservation {{no}} expired without confirmation',
      evStock: 'Stock updated for {{sku}}',
      evReady: 'Order {{po}} is ready for pickup',
      evWarranty: 'Warranty claim {{no}} opened for {{sku}}',
    },
    products: {
      title: 'Products',
      subtitle: 'Stock and incoming quantities are yours to keep current. Prices are the partner prices agreed with Treejar.',
      searchPlaceholder: 'Search by SKU or name',
      filterAll: 'All',
      filterPublished: 'Published',
      filterReview: 'Under review',
      filterDiscontinued: 'Discontinued',
      colItem: 'Product',
      colPrice: 'Partner price',
      colStock: 'Stock now',
      colIncoming: 'Incoming',
      colEta: 'ETA',
      colStatus: 'Status',
      colUpdated: 'Last updated',
      hint: 'Edit stock and incoming quantity inline — the change is visible to Treejar immediately after saving.',
      save: 'Save changes',
      savedToast: 'Stock updated for {{count}} products',
      dirty: '{{count}} unsaved changes',
      markDiscontinued: 'Mark as discontinued',
      discontinuedToast: '{{count}} products marked as discontinued',
      selected: '{{count}} selected',
      selectAll: 'Select all products',
      selectRow: 'Select {{sku}}',
      stockNow: 'Stock now',
      incoming: 'Incoming',
      eta: 'ETA',
      empty: 'No products match this filter.',
      mobileNote: 'Large stock field for warehouse use',
      saveRow: 'Save',
      rowSaved: '{{sku}} saved · stock {{count}}',
      priceNote: 'Partner price in AED, excluding VAT',
      unitsInStock: '{{count}} units',
    },
    upload: {
      title: 'Upload price list',
      subtitle: 'Send a PDF, Excel file or phone photos of your price list. We read the tables, you review what was recognised, then confirm the new version.',
      drop: 'Drop your price list here',
      dropSub: 'PDF, XLSX, CSV, JPG or PNG · up to 40 MB',
      browse: 'Choose file',
      formats: 'Accepted formats',
      fileChosen: '{{name}} · {{pages}} pages',
      stepUpload: 'Upload',
      stepReview: 'Review items',
      stepDiff: 'Compare',
      stepDone: 'Published',
      parsing: 'Reading your price list',
      parsingSub: 'Page {{page}} of {{total}} — {{count}} items recognised so far',
      parsingNote: 'Keep this tab open. Nothing is published until you confirm.',
      reviewTitle: 'Review recognised items',
      reviewSub: 'Low-confidence rows are highlighted. Edit any cell before publishing.',
      confidenceHigh: 'High',
      confidenceMedium: 'Check',
      confidenceLow: 'Low',
      lowHint: '{{count}} rows need your attention before publishing.',
      colItem: 'Item',
      colSku: 'SKU',
      colPrice: 'Partner price',
      colStock: 'Stock now',
      colIncoming: 'Incoming',
      colEta: 'ETA',
      colConfidence: 'Confidence',
      confirmItems: 'Continue to comparison',
      diffTitle: 'Changes vs version {{version}}',
      diffSub: 'Only differences are shown. Publishing replaces the previous version.',
      diffNew: 'New items',
      diffRemoved: 'Removed',
      diffPrice: 'Price changes',
      diffStock: 'Stock changes',
      colChange: 'Change',
      colWas: 'Was',
      colNow: 'Now',
      publish: 'Confirm and publish',
      publishTitle: 'Publish version {{version}}?',
      publishSub: '{{count}} items from your price list become the active version. Treejar sees the new prices and stock within a minute.',
      publishConfirm: 'Publish version',
      publishedToast: 'Version {{version}} published · {{count}} items updated',
      historyTitle: 'Upload history',
      historySub: 'Every published version is kept for audit.',
      colVersion: 'Version',
      colDate: 'Uploaded',
      colItems: 'Items',
      colStatus: 'Status',
      colChanges: 'Changes',
      active: 'Active',
      superseded: 'Superseded',
      uploadNew: 'Upload another file',
      recognized: '{{count}} items recognised',
      reset: 'Start over',
      fileName: 'Price list October 2026.xlsx',
      lowRowsLabel: 'rows need review',
    },
    demand: {
      title: 'Demand',
      subtitle: 'How often Treejar specifications asked for your models in the last 90 days, and what could not be fulfilled.',
      chartTitle: 'Units requested in Treejar specifications',
      chartSub: 'By model · last 90 days · quantities requested, not ordered',
      chartLegend: 'Units requested',
      last90: 'Last 90 days',
      colModel: 'Model',
      colAdded: 'Added to specifications',
      colReserved: 'Units reserved',
      colOrdered: 'Units ordered',
      colMissing: 'Requested but missing',
      missingHint: 'out of stock',
      hintTitle: 'Restock opportunity',
      hintBody: 'CH-229A: 3 requests could not be fulfilled because stock was zero. Restocking 40 units would cover the average monthly demand.',
      hintCta: 'Update stock',
      unitsLabel: 'units',
      footer: 'Based on {{count}} Treejar specifications. Customer names and resale prices are never shown.',
      times: '{{count}}×',
      requestedUnits: '{{count}} units',
    },
    reservations: {
      title: 'Reservations',
      subtitle: 'Treejar holds your stock for a client specification for 7 days. Confirm to keep it held, or decline with a reason.',
      filterAll: 'All',
      confirmedToast: 'Reservation {{no}} confirmed for Treejar',
      declinedToast: 'Reservation {{no}} declined · Treejar has been notified',
      declineTitle: 'Decline reservation {{no}}',
      declineSub: 'Treejar sees your reason. The stock is released back to the catalog immediately.',
      declineReason: 'Reason',
      declinePlaceholder: 'For example: stock reserved for a confirmed order',
      declineSubmit: 'Decline reservation',
      colNumber: 'Reservation',
      colSpec: 'Treejar specification',
      colItems: 'Items',
      colQty: 'Units',
      colCreated: 'Created',
      colExpires: 'Expires',
      colStatus: 'Status',
      colActions: 'Actions',
      confirmBtn: 'Confirm',
      declineBtn: 'Decline',
      empty: 'No reservations with this status.',
      note: 'Reservations do not block your stock from other Treejar orders until you confirm them.',
      expiresIn: 'in {{count}} days',
      expiresToday: 'today',
      expiredOn: 'expired {{date}}',
      units: '{{count}} units',
      itemLine: '{{sku}} × {{qty}}',
      specNote: 'No client name is shown — only the specification number.',
    },
    orders: {
      title: 'Orders',
      subtitle: 'Purchase orders from Treejar at your partner price. Pickup is always organised by Treejar from your warehouse.',
      colPo: 'Order',
      colDate: 'Date',
      colItems: 'Items',
      colUnits: 'Units',
      colAmount: 'Amount',
      colStatus: 'Status',
      colAction: '',
      open: 'Open',
      empty: 'No orders with this status.',
      note: 'Amounts are at your partner price, before VAT. Client prices are never shared.',
      kpiOpen: 'Open orders',
      kpiConfirm: 'Waiting for your confirmation',
      kpiPickup: 'Ready for pickup',
      kpiMonth: 'This month',
      unitsCount: '{{count}} units',
    },
    order: {
      back: 'Orders',
      notFound: 'Order not found',
      meta: '{{partner}} · created {{created}} · pickup by Treejar',
      confirm: 'Confirm order',
      confirmedToast: 'Order {{po}} confirmed · Treejar can plan the pickup',
      ready: 'Set ready date',
      readyToast: 'Ready date set to {{date}}',
      replacement: 'Offer replacement',
      replacementTitle: 'Offer a replacement',
      replacementSub: 'Choose another model you can supply instead of the missing item.',
      replacementSelect: 'Replacement model',
      replacementSubmit: 'Send offer',
      replacementToast: 'Replacement offer sent to your Treejar manager',
      markReady: 'Mark ready for pickup',
      markReadyToast: 'Order {{po}} marked ready for pickup',
      linesTitle: 'Order lines',
      linesSub: 'Quantities and partner prices as agreed when the order was placed.',
      colSku: 'SKU',
      colItem: 'Product',
      colQty: 'Qty',
      colUnit: 'Partner price',
      colAmount: 'Amount',
      total: 'Total at partner price',
      units: '{{count}} units',
      docsTitle: 'Documents',
      docsSub: 'Invoice and delivery note for this order',
      invoice: 'Invoice',
      deliveryNote: 'Delivery note',
      uploadInvoice: 'Upload document',
      uploadNote: 'PDF or photo · up to 10 MB',
      uploaded: '{{name}} uploaded',
      messagesTitle: 'Messages with Treejar',
      messagesSub: 'Your Treejar manager replies here',
      messagePlaceholder: 'Write a message to your Treejar manager',
      send: 'Send',
      pickupNote: 'Pickup is always done by Treejar from your warehouse. There is no delivery obligation on your side.',
      pickupTitle: 'Pickup',
      stepper: {
        new: 'New',
        confirmed: 'Confirmed',
        awaiting: 'Awaiting payment',
        paid: 'Paid',
        ready: 'Ready for pickup',
        picked: 'Picked up',
        closed: 'Closed',
      },
      nextStep: 'Next step',
      readyDateLabel: 'Ready date',
      readyDateSubmit: 'Save date',
      partner: 'Partner',
      created: 'Created',
      docEmpty: 'No documents uploaded yet.',
      threadEmpty: 'No messages yet.',
      requested: 'Requested',
    },
    finance: {
      title: 'Finance',
      subtitle: 'Invoices, payment status and what Treejar owes you next.',
      paidMonth: 'Paid this month',
      paidMonthHint: '2 invoices settled',
      awaiting: 'Awaiting payment',
      awaitingHint: '2 invoices · due 2–6 Nov',
      next: 'Next expected payment',
      nextHint: 'after client payment clears',
      bannerTitle: 'How Treejar pays partners',
      bannerBody: 'Treejar pays partners in line with the client\'s payment: client prepayment → prepayment to you, balance after the client pays.',
      invoicesTitle: 'Invoices',
      invoicesSub: 'Your invoices to Treejar and their current status',
      colInvoice: 'Invoice',
      colPo: 'Order',
      colAmount: 'Amount',
      colStatus: 'Status',
      colDue: 'Due date',
      uploadInvoice: 'Upload invoice',
      downloadStatement: 'Download statement',
      statementToast: 'Statement for October 2026 prepared',
      invoiceToast: 'Invoice sent to Treejar accounting',
      invoiceTitle: 'Upload an invoice',
      invoiceSub: 'Attach the invoice for a delivered order. Treejar accounting is notified.',
      invoiceAmount: 'Amount, AED',
      invoicePo: 'Purchase order',
      submit: 'Send invoice',
      empty: 'No invoices yet.',
      note: 'All amounts in AED. Partner prices exclude VAT.',
      dueLabel: 'Due {{date}}',
    },
    warranty: {
      title: 'Warranty',
      subtitle: 'Claims Treejar opened for your products. Reply, agree a replacement or close the case.',
      colClaim: 'Claim',
      colPo: 'Order',
      colItem: 'Item',
      colStatus: 'Status',
      colUpdated: 'Last update',
      empty: 'No warranty claims.',
      back: 'Warranty',
      notFound: 'Claim not found',
      description: 'What happened',
      photos: 'Photos from Treejar',
      reply: 'Reply to Treejar',
      replyPlaceholder: 'Describe the inspection result, replacement plan or delivery date',
      send: 'Send reply',
      agree: 'Agree replacement',
      agreedToast: 'Replacement agreed · Treejar logistics will collect the faulty unit',
      replyToast: 'Reply sent to your Treejar manager',
      claimMeta: '{{po}} · {{sku}} · reported {{date}}',
      reported: 'Reported',
      resolution: 'Resolution',
      warrantyNote: 'Replacement units are shipped free of charge. Treejar collects the faulty item at the same time.',
      statusOpen: 'Open',
      statusAgreed: 'Replacement agreed',
      statusClosed: 'Closed',
      open: 'Open claim',
      claimCount: '{{count}} open claims',
      resolveTitle: 'Resolution',
      resolveBody: 'Replacement agreed for {{sku}}. Collection planned with the next Treejar pickup.',
    },
    contract: {
      title: 'Contract & terms',
      subtitle: 'Your resale agreement with Treejar and the commercial terms that apply to every order.',
      preview: 'Contract preview',
      download: 'Download contract',
      downloaded: 'Contract PDF downloaded',
      status: 'Status',
      statusActive: 'Active · signed by both parties',
      signedOn: 'Signed',
      validUntil: 'Valid until',
      termsTitle: 'Commercial terms',
      termsSub: 'Agreed with Treejar and applied to all orders and reservations',
      discount: 'Partner discount',
      discountValue: '22% off your list price',
      specialTitle: 'Special offer items',
      specialValue: 'CH-229A and HY-128C · no discount',
      minResaleTitle: 'Minimum resale price',
      minResaleValue: 'Treejar may not resell below 1.15× your partner price',
      reservationTitle: 'Reservation period',
      reservationValue: '7 days from the moment you confirm',
      paymentTitle: 'Payment',
      paymentValue: 'Mirrored to the client payment · prepayment then balance',
      pickupTitle: 'Pickup',
      pickupValue: 'Always by Treejar from your warehouse',
      note: 'To change terms, contact your Treejar manager.',
      managerTitle: 'Your Treejar manager',
      managerSub: 'Contract, terms and commercial questions',
      managerName: 'Layla Hassan',
      managerRole: 'Partner manager · Treejar Trading LLC',
      managerPhone: '+971 50 214 8890',
      managerEmail: 'layla@treejartrading.ae',
      contact: 'Message on WhatsApp',
      contactToast: 'WhatsApp chat with Layla Hassan prepared',
      docsTitle: 'Documents',
      docContract: 'Resale agreement',
      docTerms: 'Commercial terms annex',
      docPriceList: 'Price list v12',
      docVersion: 'PDF · version 3 · 1.4 MB',
      pageOf: 'Page {{page}} of {{total}}',
      contractTitle: 'RESALE AGREEMENT',
      contractParty: 'Treejar Trading LLC — Al Quoz Industrial 4, Dubai, UAE',
      contractCounterparty: 'Al Kanz Office Furniture Tr — Warehouse No.6, Industrial Area 18, Sharjah, UAE',
      signature: 'Signed for Al Kanz Office Furniture Tr',
      signatureName: 'Aisha Al Kanz · Owner',
    },
    team: {
      title: 'Team',
      subtitle: 'People from your company who can sign in to the portal, and what they are allowed to do.',
      invite: 'Invite user',
      colName: 'Name',
      colEmail: 'Email',
      colRole: 'Role',
      colLast: 'Last login',
      colStatus: 'Status',
      roleOwner: 'Owner',
      roleWarehouse: 'Warehouse',
      roleSales: 'Sales',
      roleAccounting: 'Accounting',
      statusActive: 'Active',
      statusInvited: 'Invited',
      inviteTitle: 'Invite a team member',
      inviteSub: 'They receive an email with a link to set a password.',
      inviteName: 'Full name',
      inviteEmail: 'Work email',
      inviteRole: 'Role',
      inviteSubmit: 'Send invitation',
      invitedToast: 'Invitation sent to {{email}}',
      notifTitle: 'Notifications',
      notifSub: 'Choose how you want to be told about each event',
      notifEvent: 'Event',
      notifEmail: 'Email',
      notifWhatsapp: 'WhatsApp',
      notifSaved: 'Notification settings saved',
      savedToast: 'Team settings updated',
      evOrders: 'New order or reservation',
      evPayments: 'Payment received',
      evReservations: 'Reservation expiring',
      evStock: 'Stock update reminder',
      evWarranty: 'Warranty claim opened',
      evPriceList: 'Price list published',
      seats: '{{used}} of {{total}} seats used',
      lastNever: 'Never signed in',
      remove: 'Remove',
      removedToast: 'Access removed for {{name}}',
      note: 'The partner Owner always sees prices and payments. Warehouse users can only update stock.',
    },
  },
};